import { useSelector } from 'react-redux'
import { selectAuthStatus } from '../../selectors/users'
import { LoadingPage } from './loading_page'

// Gate for private, user-dependent pages. Now that the app renders before
// GET /users/me settles (no global blocking splash — see AuthGate), these pages
// must not render during the ambiguous "loading" window: doing so causes false
// redirects (user looks unauthenticated), null derefs (currentUser.id) and forms
// that capture an empty user into useState at mount and never re-fill.
//
// It only holds off the 'loading' state — 'anonymous' falls through so each page
// keeps handling logged-out visitors its own way. Public pages are intentionally
// NOT wrapped, so they still paint instantly.
export const RequireUser = ({ children }) => {
  const authStatus = useSelector(selectAuthStatus)
  if (authStatus === 'loading') return <LoadingPage />
  return children
}
